import type {ISort} from '../types';

export type EditEffectsSortOrderParams<D extends object, S extends keyof D> = {
	sortableFields: Readonly<S[]> | S[];
	originalData?: D;
	sort: ISort<S>;
	updatedData: D;
};

export const editEffectsSortOrder = <D extends object, S extends keyof D>({
	sortableFields,
	originalData,
	updatedData,
	sort,
}: EditEffectsSortOrderParams<D, S>) => {
	// we cant know
	if (!originalData) return true;
	return sortableFields.some(
		(field) =>
			sort.field === field && originalData[field] !== updatedData[field],
	);
};

export default editEffectsSortOrder;
